import React from 'react';
import styled from 'styled-components';

import logoProductionSrc from '../assets/icons-env/logo.png';
import logoDevelopmentSrc from '../assets/icons-env/logo-development.png';
import logoStagingSrc from '../assets/icons-env/logo-staging.png';

import faviconEmptySrc from '../assets/icons-env/favicon-empty.png';

export const [logoSrc, logoLoginSrc, logoSidebarSrc] = (
    process.env.REACT_APP_DXTOOLS_ENV === 'development'
  ? [logoDevelopmentSrc, logoDevelopmentSrc, logoDevelopmentSrc]
  : process.env.REACT_APP_DXTOOLS_ENV === 'staging'
  ? [logoStagingSrc, logoStagingSrc, logoStagingSrc]
  : [logoProductionSrc, logoProductionSrc, logoProductionSrc]
);

export const faviconSrc = faviconEmptySrc;

const WrapperHTML = ({ padding, ...props }) => <div {...props} />;

const Wrapper = styled(WrapperHTML)`
  display: flex;
  width: ${({ type }) => (type === 'login' ? '44%' : '64%')};
  transform-origin: center;
  align-items: center;
  justify-content: center;
  #sidebar & {
    transform: scale(0.8);
  }
  #admin[data-is-tablet="true"] #sidebar & {
    display: none;
  }

  margin: auto;
  margin-top: 20px;
  margin-bottom: ${({ type }) => (type === 'login' ? '60px' : '30px')};
`;

const LogoImage = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${({ type, theme }) => {
    switch (type) {
      case 'login':
        return `url(${theme.logoLogin || logoLoginSrc})`;
      case 'sidebar':
        return `url(${theme.logoSidebar || logoSidebarSrc})`;
      default:
        return `url(${theme.logoSidebar || logoSrc})`;
    }
  }};
`;

export default function Logo({ type, ...props }) {
  return (
    <Wrapper type={type} {...props}>
      <LogoImage type={type} />
    </Wrapper>
  );
}

export function renderLogo() {
  return <Logo type="login" />;
}

export function renderSidebarLogo({ expandedSidebar }) {
  return (
    <Logo
      type="sidebar"
      padding={expandedSidebar ? '50px' : '30px 20px 20px'}
    />
  );
}
